<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import DetailsView from "./actions/Details.vue";
import DispensesView from "./actions/Dispenses.vue";

export default {
  components: {
    AddView,
    DetailsView,
    DispensesView,
  },
  created() {
    this.$store.dispatch("lookups/getDoctors");
    // this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.doctorsStock.totalItems / this.filters.pageSize
      );
    },
    doctorsStock() {
      return this.$store.state.doctorsStock.doctorsMedicines;
    },
    medicines() {
      return this.medicinesList;
    },
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },
  },

  data() {
    return {
      permissions: this.$settingPermissions.doctorsStockPermissions,
      formDialog: false,
      item: {
        id: null,
        medicineName: null,
      },
      view: 0,
      quantity: null,

      filters: {
        page: 1,
        pageSize: 10,

        name: null,
        doctorId: null,
        medicineId: null,
      },
      headers: [
        { text: 'اسم الدواء', value: 'medicineName' },
        { text: 'اجمالي الكمية', value: 'stocks' },
        { text: ' الكمية المصروفة', value: 'dispenses' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      dialog: false,
      dialogType: null,
      dialogMessage: "",

      itemId: 0,
      medicinesList: [],
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("doctorsStock/getAll", this.filters);
    },
    changeDoctor() {
      this.getAll();
      this.getMedicines();
    }, 
     getMedicines() {
      this.$store.dispatch("doctorsStock/getMedicines", this.filters.doctorId).then(res => {
        this.medicinesList = res
      });
    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement view logic
    },
    viewDispenses(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
 

    back() {
      
      this.view = 0;
    },
    addStock(item) {
      this.item = item;
      this.formDialog = true;

    },
    confirmFormDialog() {
      if (this.quantity == null) {
        return false;
      }
      let vm = {
        medicineId: this.item.id,
        doctorId: this.filters.doctorId,
        quantity: this.quantity,
      }
      this.$store
        .dispatch("doctorsStock/updateStock", vm)
        .then(() => {
          this.cancelFormDialog()
        })
        .catch(() => { });

    },
    cancelFormDialog() {
      this.formDialog = false;
      this.quantity = null;
      this.item = {
        id: null,
        medicineName: null,
      };
      this.$refs.reason.reset(); // إعادة تعيين الحقول والتحقق
    },

  },
};
</script>
